import { LeadsState } from './state';

export const leadsInitialState: LeadsState = {

}